import type { TextareaHTMLAttributes } from 'react';
import { forwardRef } from 'react';
import { cn } from './utils';

type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
    error?: boolean;
};

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
    ({ className, error, ...props }, ref) => {
        return (
            <textarea
                ref={ref}
                className={cn('nx-textarea', error && 'nx-textarea--error', className)}
                aria-invalid={error || props['aria-invalid'] ? true : undefined}
                {...props}
            />
        );
    },
);

Textarea.displayName = 'Textarea';

export { Textarea };
export type { TextareaProps };
